import { useRef } from 'react';
import useManageIntegration from './hooks/useManageIntegration';
import ManageIntegrationView from './view';

/**
 * ManageIntegration modal.
 *
 * Usage:
 *   const manageModalRef = useRef();
 *
 *   // Open creation flow:
 *   manageModalRef.current.openCreate(onSuccessCallback);
 *
 *   // Open edit flow:
 *   manageModalRef.current.openEdit(integrationSummary, onSuccessCallback);
 *
 * Props:
 *   modalRef   — ref object exposed to the parent (imperative handle)
 *   community  — community data object (with .id, .plans[])
 */
export default function ManageIntegration({ modalRef, community }) {
    const communityRef = useRef(community);
    communityRef.current = community;

    const props = useManageIntegration({ communityRef });

    if (modalRef) {
        modalRef.current = {
            openCreate: props.openCreate,
            openEdit: props.openEdit,
        };
    }

    return <ManageIntegrationView {...props} community={communityRef} />;
}
